import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import CustomAttribute from './CustomAttribute';
import { FileUtil, DateUtil, CommonUtil } from '../utils';

/**
 * [Model] EntityVersionItem
 */
var EntityVersionItem = /*#__PURE__*/function () {
  function EntityVersionItem() {
    _classCallCheck(this, EntityVersionItem);
  }
  return _createClass(EntityVersionItem, null, [{
    key: "parseV2",
    value:
    // This is temp name in review if name changed

    // This is to use original name for copy.

    // BIM Plans review state

    /**
     * Parse camel case data
     */
    function parseV2(data) {
      var rowData = data || {};
      var entity = new EntityVersionItem();
      entity.id = rowData.id;
      entity.action = rowData.action;
      entity.approvalStatus = rowData.approveStatus || {};
      entity.commentsMetadata = rowData.commentsMetadata;
      entity.bubbleUrn = rowData.bubbleUrn;
      entity.bubbleViewableGuid = rowData.bubbleViewableGuid;
      entity.bubbleViewableId = rowData.bubbleViewableId;
      entity.bubbleViewableOrder = rowData.bubbleViewableOrder;
      entity.bubbleViewableUrn = rowData.bubbleViewableResourceUrn;
      entity.createTime = DateUtil.dateStringReformat(rowData.createTime);
      entity.createUserId = rowData.createUserId;
      entity.createUserName = rowData.createUserName;
      entity.entityType = rowData.entityType;
      entity.conformingStatus = rowData.conformingStatus;
      entity.extractionState = rowData.extractionState;
      entity.fileName = FileUtil.decodeFileName(rowData.fileName);
      entity.fileSize = rowData.fileSize;
      entity.forgeType = rowData.forgeType;
      entity.forgedIsCompositeDesign = rowData.forgedIsCompositeDesign;
      entity.lastModifiedTime = DateUtil.dateStringReformat(rowData.lastModifiedTime);
      entity.lastModifiedUserId = rowData.lastModifiedUserId;
      entity.lastModifiedUserName = rowData.lastModifiedUserName;
      entity.mimeType = rowData.mimeType;
      entity.name = FileUtil.decodeFileName(rowData.name);
      entity.versionName = rowData.name; // This is to use original name for copy.
      entity.originalName = rowData.originalName;
      entity.pendingName = rowData.pendingName; // This is temp name in review if name changed
      entity.snapshot = rowData.snapshot;
      entity.reviewData = rowData.reviewData;
      entity.lastApprovalStatus = rowData.lastApproveStatus;
      entity.partialExtractionFailure = rowData.partialExtractionFailure === 'true' || rowData.partialExtractionFailure === true;
      entity.processState = rowData.processState;
      entity.processResult = rowData.processResult;
      entity.reviewId = rowData.reviewId;
      entity.reviewDeleted = rowData.reviewDeleted;
      entity.revisionNumber = rowData.revisionNumber;
      entity.serviceTasksStatus = rowData.serviceTasksStatus || [];
      entity.storageUrn = rowData.storageUrn;
      entity.title = rowData.title;
      entity.urn = rowData.urn;
      entity.versionNumber = Number(FileUtil.getVersionNumber(rowData.urn));
      entity.customAttributes = (rowData.customAttributes || []).map(function (attribute) {
        return CustomAttribute.parseV2(attribute);
      });
      entity.reviewAttributes = (rowData.reviewAttributes || []).map(function (attribute) {
        return CustomAttribute.parseV2(attribute);
      });
      return entity;
    }

    /**
     * Parse snake case data
     */
  }, {
    key: "parseV1",
    value: function parseV1(data) {
      var rowData = data || {};
      var entity = new EntityVersionItem();
      entity.id = rowData.id;
      entity.action = rowData.action;
      entity.approvalStatus = rowData.approve_status || {};
      entity.bubbleUrn = rowData.bubble_urn;
      entity.bubbleViewableGuid = rowData.bubble_viewable_guid;
      entity.bubbleViewableId = rowData.bubble_viewable_id;
      entity.bubbleViewableOrder = rowData.bubble_viewable_order;
      entity.bubbleViewableUrn = rowData.bubble_viewable_resource_urn;
      entity.createTime = DateUtil.dateStringReformat(rowData.create_time);
      entity.createUserId = rowData.create_user_id;
      entity.createUserName = rowData.create_user_name;
      entity.dmCommandId = rowData.dm_command_id;
      entity.entityType = rowData.entity_type;
      entity.conformingStatus = rowData.conforming_status;
      entity.extractionState = rowData.extraction_state;
      entity.fileName = rowData.file_name;
      entity.fileSize = rowData.file_size;
      entity.forgeType = rowData.forge_type;
      entity.forgedIsCompositeDesign = rowData.forged_is_composite_design;
      entity.lastModifiedTime = DateUtil.dateStringReformat(rowData.update_time);
      entity.lastModifiedUserId = rowData.update_user_id;
      entity.lastModifiedUserName = rowData.updated_by;
      entity.lineageUrn = rowData.lineage_urn;
      entity.mimeType = rowData.mime_type;
      entity.name = FileUtil.decodeFileName(rowData.name);
      entity.versionName = rowData.name; // This is to use original name for copy.
      entity.originalName = FileUtil.decodeFileName(rowData.original_name);
      entity.parentLineageFileName = rowData.parent_lineage_file_name;
      entity.partialExtractionFailure = rowData.partial_extraction_failure;
      entity.processState = rowData.process_state;
      entity.processResult = rowData.process_result;
      entity.reviewId = rowData.review_id;
      entity.reviewDeleted = rowData.review_deleted;
      entity.reviewState = rowData.review_state;
      entity.revisionNumber = rowData.revision_number;
      entity.storageUrn = rowData.storage_urn;
      entity.title = rowData.title;
      entity.urn = rowData.urn;
      entity.versionNumber = rowData.version_number;
      entity.customAttributes = Array.isArray(rowData.custom_attributes) ? rowData.custom_attributes.map(function (attribute) {
        return CustomAttribute.parseV1(attribute);
      }) : [];
      return entity;
    }

    /**
     * Parse camel case data
     */
  }, {
    key: "parseV3",
    value: function parseV3(data) {
      var rowData = data || {};
      var entity = new EntityVersionItem();
      entity.urn = rowData.urn;
      entity.id = rowData.id;
      entity.createTime = DateUtil.dateStringReformat(rowData.createdAt);
      entity.createUserId = rowData.createdBy;
      entity.createUserName = rowData.createdByName;
      entity.lastModifiedTime = DateUtil.dateStringReformat(rowData.updatedAt);
      entity.lastModifiedUserId = rowData.updatedBy;
      entity.lastModifiedUserName = rowData.updatedByName;
      entity.storageUrn = rowData.storageUrn;
      entity.fileSize = rowData.storageSize;
      entity.name = rowData.name;
      entity.fileName = rowData.uploadFileName;
      entity.processState = rowData.processingState;
      entity.processResult = rowData.processResult;
      entity.entityType = rowData.entityType;
      entity.conformingStatus = rowData.conformingStatus;
      entity.bubbleUrn = rowData.bubbleUrn;
      entity.bubbleViewableGuid = rowData.bubbleViewableGuid;
      entity.bubbleViewableOrder = rowData.bubbleViewableOrder;
      entity.bubbleViewableUrn = rowData.bubbleViewableUrn;
      entity.revisionNumber = rowData.revision;
      entity.mimeType = rowData.mimeType || CommonUtil.getValue(rowData, 'forged.mimeType.value');
      entity.approvalStatus = rowData.approvalStatus || {};
      entity.extractionState = rowData.extractionStatus;
      entity.partialExtractionFailure = rowData.partialExtractionFailure === 'true' || rowData.partialExtractionFailure === true;
      entity.versionNumber = rowData.versionNumber;
      entity.customAttributes = (rowData.customAttributes || []).map(function (attribute) {
        return CustomAttribute.parseV3(attribute);
      });
      entity.action = rowData.action;
      entity.forgeType = CommonUtil.getValue(rowData, 'forged.type');
      entity.forgedIsCompositeDesign = CommonUtil.getValue(rowData, 'forged.isCompositeDesign.value') === 'true';

      // Newly added
      entity.description = rowData.description;
      entity.uploadId = rowData.uploadId;
      entity.documentType = rowData.documentType;
      entity.sharedModel = rowData.sharedModel;

      // Added for pdf extraction indicator
      entity.processToFileTargetFolderUrn = rowData.processToFileTargetFolderUrn;
      // Added to remove cloud model icon of c4r by copy
      entity.copyFromVersion = rowData.copyFromVersion;
      // Add extendedProperties
      entity.extendedProperties = FileUtil.getExtMetaProperties(rowData.extendedProperties);
      return entity;
    }
  }]);
}();
export { EntityVersionItem as default };